import Vue from "vue";
import Router from "vue-router";
import layout from "../layout";
import { store } from './store'
import Socket from "./socket";
import jwt_decode from "jwt-decode";
import moment from "moment";

Vue.use(Router);

const routes =
  [
    {
      path: "/",
      component: layout,
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import("@/pages/competitions/active-competitions")
        }
      ]
    },
    {
      path: "/competitions",
      component: layout,
      children: [
        {
          path: "active-competitions",
          name: "active-competitions",
          component: () => import("@/pages/competitions/active-competitions"),
          meta: { title: 'Competitions' }
        },
        {
          path: "my-entries",
          name: "my-entries",
          component: () => import("@/pages/competitions/my-entries"),
          meta: {
            requiresAuth: true,
            title: 'My Entries'
          }
        },
        {
          path: "expired-entries",
          name: "expired-entries",
          component: () => import("@/pages/competitions/expired-entries"),
          meta: {
            requiresAuth: true,
            title: 'Expired Entries'
          }
        },
        {
          path: "player-ratings",
          name: "player-ratings",
          component: () => import("@/pages/competitions/player-ratings"),
          meta: { title: 'Player Ratings' }
        },
        {
          path: "past-winners",
          name: "past-winners",
          component: () => import("@/pages/competitions/past-winners"),
          meta: { title: 'Past Winners' }
        },
        {
          path: "fan-leaderboard",
          name: "fan-leaderboard",
          component: () => import("@/pages/competitions/fan-leaderboard"),
          meta: { title: 'Fan Leaderboard' }
        },
        {
          path: "questions",
          name: "questions",
          component: () => import("@/pages/competitions/questions"),
          meta: {
            requiresAuth: true,
            title: 'Questions'
          }
        },
        {
          path: "questions-times-up",
          name: "questions-times-up",
          component: () => import("@/pages/competitions/questions-times-up"),
          meta: {
            requiresAuth: true,
            title: 'Questions Times Up'
          }
        },
        {
          path: "entered",
          name: "entered",
          component: () => import("@/pages/competitions/entered"),
          meta: {
            requiresAuth: true,
            title: 'Entered'
          }
        },
        {
          path: "voting",
          name: "voting",
          component: () => import("@/pages/competitions/voting"),
          meta: {
            requiresAuth: true,
            title: 'Voting'
          }
        },
        {
          path: "entry-home",
          name: "entry-home",
          component: () => import("@/pages/competitions/entry-home"),
          meta: {
            requiresAuth: true,
            title: 'Entry Home'
          }
        },
        {
          path: "rating",
          name: "rating",
          component: () => import("@/pages/competitions/rating"),
          meta: {
            requiresAuth: true,
            title: 'Rating'
          }
        },
        {
          path: "buy-entry",
          name: "buy-entry",
          component: () => import("@/pages/competitions/buy-entry"),
          meta: {
            requiresAuth: true,
            title: 'Buy Entry'
          }
        }
      ]
    },
    {
      path: "/auth",
      component: layout,
      children: [
        {
          path: "login",
          name: "login",
          component: () => import("@/pages/auth/login"),
          meta: { title: 'Login' }
        },
        {
          path: "logout",
          name: "logout",
          component: () => import("@/pages/auth/logout"),
          meta: { title: 'Logout' }
        },
        {
          path: "join",
          name: "join",
          component: () => import("@/pages/auth/join"),
          meta: { title: 'Join' }
        },
        {
          path: "confirm",
          name: "confirm",
          component: () => import("@/pages/auth/confirm"),
          meta: { title: 'Confirm' }
        },
        {
          path: "profile",
          name: "profile",
          component: () => import("@/pages/auth/profile"),
          meta: {
            requiresAuth: true,
            title: 'Profile'
          }
        },
        {
          path: "reset-password",
          name: "reset-password",
          component: () => import("@/pages/auth/reset-password"),
          meta: { title: 'Reset Password' }
        },
        {
          path: "confirm-reset-password",
          name: "confirm-reset-password",
          component: () => import("@/pages/auth/confirm-reset-password"),
          meta: { title: 'Confirm Reset Password' }
        },
        {
          path: "change-password",
          name: "change-password",
          component: () => import("@/pages/auth/change-password"),
          meta: {
            requiresAuth: true,
            title: 'Change Password'
          }
        },
        {
          path: "edit-profile",
          name: "edit-profile",
          component: () => import("@/pages/auth/edit-profile"),
          meta: {
            requiresAuth: true,
            title: 'Edit Profile'
          }
        },
        {
          path: "unsubscribe",
          name: "unsubscribe",
          component: () => import("@/pages/auth/unsubscribe")
        }
      ]
    },
    {
      path: "/wallet",
      component: layout,
      children: [
        {
          path: "transactions",
          name: "transactions",
          component: () => import("@/pages/wallet/transactions"),
          meta: {
            requiresAuth: true,
            title: 'Transactions'
          }
        },
        {
          path: "honey-points",
          name: "honey-points",
          component: () => import("@/pages/wallet/honey-points"),
          meta: {
            requiresAuth: true,
            title: 'Honey Points'
          }
        },
        {
          path: "buy-credits",
          name: "buy-credits",
          component: () => import("@/pages/wallet/buy-credits"),
          meta: {
            requiresAuth: true,
            title: 'Buy Credits'
          }
        },
        {
          path: "payment-stub",
          name: "payment-stub",
          component: () => import("@/pages/wallet/payment-stub"),
          meta: {
            requiresAuth: true,
            title: 'Payment Stub'
          }
        },
        {
          path: "payment-result",
          name: "payment-result",
          component: () => import("@/pages/wallet/payment-result"),
          meta: {
            requiresAuth: true,
            title: 'Payment Result'
          }
        }
      ]
    },
    {
      path: "/static",
      component: layout,
      children: [
        {
          path: "about",
          name: "about",
          component: () => import("@/pages/static/about"),
          meta: { title: 'About' }
        },
        {
          path: "contact",
          name: "contact",
          component: () => import("@/pages/static/contact"),
          meta: { title: 'Contact' }
        },
        {
          path: "terms-and-conditions",
          name: "terms-and-conditions",
          component: () => import("@/pages/static/terms-and-conditions"),
          meta: { title: 'Terms and Conditions' }
        },
        {
          path: "privacy-policy",
          name: "privacy-policy",
          component: () => import("@/pages/static/privacy-policy"),
          meta: { title: 'Privacy Policy' }
        },
        {
          path: "faq",
          name: "faq",
          component: () => import("@/pages/static/faq"),
          meta: { title: 'FAQ' }
        },
        {
          path: "sport-clubs",
          name: "sport-clubs",
          component: () => import("@/pages/static/sport-clubs"),
          meta: { title: 'Sport Clubs' }
        },
      ]
    }
  ]

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  base: '/app'
});

router.beforeEach((to, from, next) => {

  document.title = (to.meta.title === undefined) ? "Fanhive" : "Fanhive | " + to.meta.title;
  store.commit('setShowSlideMenu', '');

  if (store.getters.jwtToken === null && Vue.localStorage.get('jwtToken')) {
    store.commit('setJwtToken', Vue.localStorage.get('jwtToken'));
    store.commit('setIsLoggedIn', true);
  }
  if (store.getters.userSub === null && Vue.localStorage.get('userSub')) {
    store.commit('setUserSub', JSON.parse(Vue.localStorage.get('userSub')));
  }
  if (store.getters.wallet === null && Vue.localStorage.get('wallet')) {
    store.commit('setWallet', JSON.parse(Vue.localStorage.get('wallet')));
  }

  if(store.getters.jwtToken !== null){
    var decodedJwt = jwt_decode(store.getters.jwtToken);
    if(decodedJwt.exp <= moment().unix()){
      if(to.meta.requiresAuth && to.name !== 'logout'){
        next({name: 'logout'});
      }
    }
  }

  if (store.getters.acceptedCookies === null && Vue.localStorage.get('acceptedCookies')) {
    console.log('set cookie accepted view');
    store.commit('setAcceptedCookies', Vue.localStorage.get('acceptedCookies') === "true");
  }
  if (store.getters.viewedCookiesPopup === null && Vue.localStorage.get('viewedCookiesPopup')) {
    console.log('set cookie popup viewed view');
    store.commit('setViewedCookiesPopup', Vue.localStorage.get('viewedCookiesPopup') === "true");
  }

  if((Socket.getState() === 0 || Socket.getState() === 3)&& store.getters.userSub !== null) {
    console.log('Socket seems to have closed, must reconnect: ' + new Date().toString());
    Socket.connect(store.getters.userSub.userName);
  }

  
  if(to.name === 'confirm' || to.name === 'join' || to.name === 'login'){
    store.commit('setHideYellowBar', true);
    console.log('hiding yellow bar');
  } else {
    store.commit('setHideYellowBar', false);
    console.log('show yellow bar');
  }

  if(from.name === 'rating' && store.getters.noSubmitRatingCount > 0){
    console.log('aborting navigating due to no ratings submitted');
    store.commit('setDisplayNoSubmitDialog', true);
    next(false);
  } else {
    next();
  }
})

export default router;
